// extracted by mini-css-extract-plugin
export default {"btn__btn":"styles_btn__btn__JKkmr"};